import type { CoverSheetConfigCard } from '../../../types';

export const buyersAgentCard = {
  id: 'buySideContacts.dualRepBuyersAgent',
  innerTitle: "Tenant's Agent x",
  outerTitle: "Tenant's Agents",
  addableTitle: "Tenant's Agent x",
  fields: {},
} satisfies CoverSheetConfigCard;
